/* WISAMIN - approximate local-price hint + the flag currency picker.
   The store sells and charges in Singapore dollars. This only ADDS an estimate
   beside the SGD price so shoppers in MY/PH - or MAX checking Thai pricing -
   can judge the cost. It never changes a price, a cart value or anything sent
   to checkout, and it stands down the moment Shopify itself starts charging in
   a non-SGD currency. The picker in the header/footer writes wp_fx_cur. */
(function () {
  'use strict';

  var BASE = 'SGD';
  var API = 'https://open.er-api.com/v6/latest/SGD';
  var KEY = 'wp_fx_v2';
  var MAXAGE = 21600000;               // 6 hours

  /* Banks add a foreign-currency fee on top of the network rate. Showing the
     mid-market number alone under-quotes what the customer is really charged,
     so the estimate includes a typical fee. DBS Singapore publishes 3.25%
     (1.00% card network + 2.25% bank); other SEA banks sit close to this. */
  var FX_FEE = 0.0325;

  /* Baked-in fallback from SGD, used only if the live call fails. 22 Sep 2026. */
  var FALLBACK = { asOf: '22 Sep 2026', rates: {
    USD: 0.7837, MYR: 3.1954, PHP: 49.2089, THB: 26.0692, AUD: 1.1001,
    EUR: 0.6832, GBP: 0.5860, JPY: 123.2919, HKD: 6.1489, TWD: 24.8782,
    KRW: 1077.14, AED: 2.8783, IDR: 13961.95, VND: 20348.93, CNY: 5.2604, INR: 75.0871
  }};

  var CUR = {
    USD: { s: 'US$', d: 2 }, MYR: { s: 'RM',  d: 2 }, PHP: { s: '₱', d: 2 },
    THB: { s: '฿', d: 0 }, AUD: { s: 'A$', d: 2 }, EUR: { s: '€', d: 2 },
    GBP: { s: '£', d: 2 }, JPY: { s: '¥', d: 0 }, HKD: { s: 'HK$', d: 2 },
    TWD: { s: 'NT$', d: 0 }, KRW: { s: '₩', d: 0 }, AED: { s: 'AED ', d: 2 },
    IDR: { s: 'Rp', d: 0 }, VND: { s: '₫', d: 0 }, CNY: { s: 'CN¥', d: 2 },
    INR: { s: '₹', d: 0 }
  };
  var BY_COUNTRY = { MY:'MYR', PH:'PHP', TH:'THB', US:'USD', AU:'AUD', HK:'HKD',
    TW:'TWD', KR:'KRW', JP:'JPY', ID:'IDR', VN:'VND', AE:'AED', GB:'GBP', CN:'CNY',
    IN:'INR', DE:'EUR', FR:'EUR', NL:'EUR', IT:'EUR', ES:'EUR' };

  function store(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }

  function active() {
    return (window.Shopify && Shopify.currency && Shopify.currency.active) || BASE;
  }

  function pickCurrency() {
    var forced = read('wp_fx_cur');
    if (forced === active()) return null;            // nothing to estimate
    if (forced && CUR[forced]) return forced;
    var c = (window.Shopify && Shopify.country) || '';
    if (c === 'SG') return null;                     // already the store currency
    if (BY_COUNTRY[c]) return BY_COUNTRY[c];
    var loc = (navigator.language || '').split('-')[1];
    if (loc === 'SG') return null;
    return BY_COUNTRY[loc] || 'USD';
  }

  function fmt(base, code, rate, raw) {
    var meta = CUR[code] || { s: code + ' ', d: 2 };
    var v = base * rate * (raw ? 1 : 1 + FX_FEE);
    var n = v.toFixed(meta.d);
    n = n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return meta.s + n;
  }

  /* "$24.00" / "US$1,390" -> 24 */
  function toUsd(text) {
    var m = String(text).replace(/\s/g, '').match(/-?[\d.,]+/);
    if (!m) return null;
    var raw = m[0];
    if (/,\d{2}$/.test(raw) && !/\.\d/.test(raw)) raw = raw.replace(/\./g, '').replace(',', '.');
    else raw = raw.replace(/,/g, '');
    var n = parseFloat(raw);
    return isFinite(n) ? n : null;
  }

  function paint(rates, asOf) {
    var code = pickCurrency();
    if (!code) return;                               // Singapore shoppers see SGD already
    var rate = rates[code];
    if (!rate) return;

    var targets = [
      ['.wp-pdp__price b', 'block'],
      ['.wp-card__p b', 'inline'],
      ['[data-cart-total]', 'inline']
    ];
    targets.forEach(function (t) {
      var nodes = document.querySelectorAll(t[0] + ':not([data-fx])');
      Array.prototype.forEach.call(nodes, function (el) {
        el.setAttribute('data-fx', '1');
        var usd = toUsd(el.textContent);
        if (usd === null || usd <= 0) return;
        var s = document.createElement('span');
        s.className = 'wp-fxq wp-fxq--' + t[1];
        s.setAttribute('data-fx-usd', usd);
        s.textContent = '≈ ' + fmt(usd, code, rate);
        s.title = 'Estimate only - you are charged ' + BASE + ' and your bank converts it.'
          + '\nMid-market: ' + fmt(usd, code, rate, true)
          + '\nWith a typical 3.25% bank fee: ' + fmt(usd, code, rate)
          + '\nRate as of ' + asOf + '.';
        if (el.parentNode) el.parentNode.insertBefore(s, el.nextSibling);
      });
    });

    var note = document.querySelector('[data-fx-note]');
    if (note) note.textContent = 'Prices are charged in Singapore dollars. The ' + code +
      ' figure is an estimate of what your card will actually be billed - it uses rates from '
      + asOf + ' and includes a typical 3.25% foreign-currency fee. Your own bank\'s fee may differ.';
  }

  function run() {
    /* If the store ever charges in a local currency, Shopify does it properly - stand down. */
    if (active() !== BASE) return;

    var cached = null;
    try { cached = JSON.parse(read(KEY) || 'null'); } catch (e) {}
    if (cached && cached.rates && (Date.now() - cached.t) < MAXAGE) {
      paint(cached.rates, cached.asOf);
      return;
    }
    paint(FALLBACK.rates, FALLBACK.asOf);      // show something immediately

    fetch(API, { mode: 'cors' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (!j || j.result !== 'success' || !j.rates) return;
        var asOf = new Date((j.time_last_update_unix || 0) * 1000)
          .toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
        store(KEY, JSON.stringify({ t: Date.now(), rates: j.rates, asOf: asOf }));
        /* [data-fx-usd] is set only on nodes this script created - never
           select by class alone, the theme has its own .wp-fx elsewhere. */
        document.querySelectorAll('[data-fx-usd]').forEach(function (n) { n.remove(); });
        document.querySelectorAll('[data-fx]').forEach(function (n) { n.removeAttribute('data-fx'); });
        paint(j.rates, asOf);
      })
      .catch(function () { /* fallback figures are already on screen */ });
  }

  function setCurrency(code) {
    if (code && (CUR[code] || code === BASE)) store('wp_fx_cur', code);
    else { try { localStorage.removeItem('wp_fx_cur'); } catch (e) {} }
  }
  window.wpSetFxCurrency = function (code) { setCurrency(code); location.reload(); };

  /* The picker renders every flag up front and marks the live one, so switching
     the label is a class toggle - no SVG built in JavaScript. */
  function paintPicker(root) {
    /* pickCurrency() is the single source of truth: it returns the estimate
       currency in force (stored choice first, then geo), or null when the
       shopper is simply seeing the charging currency. */
    var est = pickCurrency();
    var shown = est || active();
    if (!CUR[shown] && shown !== active()) { shown = active(); est = null; }
    root.classList.toggle('is-est', !!est);

    Array.prototype.forEach.call(root.querySelectorAll('[data-wp-cur-label]'), function (el) {
      el.textContent = shown;
    });
    Array.prototype.forEach.call(root.querySelectorAll('.wp-cur__flag > [data-f]'), function (el) {
      el.classList.toggle('is-on', el.getAttribute('data-f') === shown);
    });
    Array.prototype.forEach.call(root.querySelectorAll('.wp-cur__o'), function (el) {
      el.classList.toggle('is-on', el.getAttribute('data-cur') === shown);
    });
  }

  function bindPicker(root) {
    if (root.getAttribute('data-wp-cur') === 'on') return;
    root.setAttribute('data-wp-cur', 'on');
    paintPicker(root);

    root.addEventListener('click', function (ev) {
      var b = ev.target.closest ? ev.target.closest('.wp-cur__o') : null;
      if (!b) return;
      /* A market option keeps its native submit; we only decide whether an
         estimate should ride along with the new market. */
      setCurrency(b.getAttribute('data-fxcur'));
      if (b.type !== 'submit') { ev.preventDefault(); location.reload(); }
    });
  }

  function pickers() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-wp-cur]'), bindPicker);
  }

  function closeAll(except) {
    Array.prototype.forEach.call(document.querySelectorAll('.wp-cur__d[open]'), function (d) {
      if (d !== except) d.removeAttribute('open');
    });
  }
  document.addEventListener('click', function (ev) {
    var inside = ev.target.closest ? ev.target.closest('.wp-cur__d') : null;
    closeAll(inside);
  });
  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape') closeAll(null);
  });

  function boot() { pickers(); run(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('wp:cart:updated', run);
})();
